import { Divider } from "@shopify/polaris";
import { CSSProperties } from "react";

const AndSeparator = ({ styles, textStyles }: { styles?: CSSProperties; textStyles?: CSSProperties }) => {
    return (
        <div style={{ position: "relative", margin: "20px 0", ...styles }}>
            <Divider borderColor="border" />
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "rgb(246, 246, 247)",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    color: "rgb(109, 113, 117)",
                    fontWeight: "500",
                    boxShadow: "0 0 0 4px white",
                    ...textStyles,
                }}
            >
                AND
            </div>
        </div>
    );
};

export default AndSeparator;
